
<template>

  <div class="cbody1">

    <div class="proxzbox margintop1">



  <div ref="selectContainer" class="el-select noclick-contextmenu" style="width: 100%;position: relative;" @click="sopen=!sopen">
    <div class="el-input el-input--suffix"><!---->

      <span class="el-input__inner">{{today.name}}</span>
      <!----><span class="el-input__suffix"><span class="el-input__suffix-inner">
        <i :class="sopen? 'el-select__caret el-input__icon el-icon-arrow-up': 'el-select__caret el-input__icon el-icon-arrow-up is-reverse'"></i><!----><!----><!----><!----><!----></span><!----></span><!----><!----></div>
        <div class="el-select-dropdown el-popper"  x-placement="bottom-start" style="width:100%" :class="sopen? 'el-select-dropdown el-popper is-close': 'el-select-dropdown el-popper '">
      
            <div class="el-select-dropdown__wrap ">
              <ul class="el-scrollbar__view el-select-dropdown__list"><!---->
                <li :class="item.id==today.program_id? 'el-select-dropdown__item selected' :'el-select-dropdown__item' "  v-for="item in prodata"
      :key="item.id"
      :label="item.name"
      :value="item.id" @click="cgpro(item)"><span>{{item.name}}</span></li>
        
              </ul>
         
           </div><!----><div x-arrow="" class="popper__arrow" style="left: 35px;"></div></div>
    </div>
    </div>
      <div class="calendarBox" v-if="today.program_id!=''" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
      <vue-hash-calendar
       ref="calendar"
      model="inline"
  
      format="YY-MM-DD"
      lang="CN"
      :visible="true"
      :disabledWeekView="true"
      :minDate="new Date()"
      :init-date="initDate"

  
       :weekStart=thisenday
       :disabledDate=disabledDate
       @change="onDateChange"
       

      >

      <template  slot="day" slot-scope="scope">
        <slot name="day" :date="scope.date" :extendAttr="scope.extendAttr">
          <div class="timeset">
            <p :class="getClass(scope.date)" :style="getbgcolor(scope.date)">
                {{scope.date.day}}
            </p>
            <p :class="getClass2(scope.date)"></p>
          
    
          </div>
      
        </slot>
      </template>
    </vue-hash-calendar>
      <div class="godbtnbox">
      <button @click="goToPrevWeek" class="godbtn">上一月</button>
  <button @click="goToNextWeek" class="godbtn">下一月</button>
</div>
  </div>

  <div class="bookxzbox" v-if="todytime.length>0">
     <div class="colorbox">
       <div class="colorlist" v-for="item in colorlist" :key="item.id">
        <div class="xian" :style="{'background':item.color}"></div>
        <p class="p1">{{item.name}}</p>
       </div>
       
     </div>
       <div :class="clarr.time== item.dateTime ? 'xzbtn this':'xzbtn'" :style="{'background':item.color}" v-for="item in todytime" :key="item.dateTime" @click="xzsj(item)">
         {{item.stime}}
       </div>
  </div>
  <div class="bookxzbox" v-if="todytime.length==0 && today.program_id!=''">沒有可預約的時段</div>
  <div class="proxzbox" v-if="clarr.time">
  <div class="coll">
     <div class="collist">
     <div class="line">
      <p class="ptitle">請選擇療程：</p>
     </div>
      <div v-for="item2 in sub_menus" :key="item2.name" @click="proxz(item2)" class="line">
    <p :class="xzxm.includes(item2.id) ? 'kuang this':'kuang'"></p><p class="ptitle">{{item2.name}}</p> 
    </div>
     </div>

  </div>

<el-input
type="textarea"
:rows="3"
placeholder="有無野想預先講比店主聽？"
v-model="clarr.remark" style="width:100%;margin-top:0.3rem;resize:none">
</el-input>
  </div>
   <div class="ystk" v-if="ystk!=''">

      <input type="checkbox" v-model="tkqd" :class="tkqd?'tkqd this':'tkqd'"> 
      <div class="line" @click="dialogVisible=true">
        《必須閱讀療程細則》
      </div>
   </div>

    <div :class="tkqd?'bkbtn this':'bkbtn'" @click="bn()">Book Now</div>
   <el-dialog
title="必須閱讀療程細則"
:visible.sync="dialogVisible"
width="80%"
>
<div v-html="ystk"></div>
<span slot="footer" class="dialog-footer">
  <el-button @click="dialogVisible = false">取 消</el-button>
  <el-button type="primary" @click="tkqdbtn()">確 定</el-button>
</span>
</el-dialog>
  </div>
  
</template>

<script>
import { userColor,Working,dayWorking,program,orderSave,orderEdit} from '../../api/userMG'


export default {
  name:'Booknow',
  data() {
    return {
      sopen:true,
      dialogVisible:false,
      activeName: '',
      huaimg:require("@/assets/img/hua4.png"),
      initDate: new Date(),
      ifnow:true,
      iftips:false,
      tips:"You've got nothing booked at the moment.",
      listData:[],
      userdata : JSON.parse(localStorage.getItem('userdata')) ,
      params:{
          status:1,
        client_id:JSON.parse(localStorage.getItem('userdata')).id
      },
      usernav:[
      {
        title:'My Bookings',
        path:'/user/Bookings',

      },
      {
        title:'My Account',
        path:'/user/Index',

      }]
      ,
      today: {
      year: '',
      month: '',
      day: '',
      program_id:'',
      name:'請選擇項目'
      },
      weeks:0,

      thisenday:this.getDayOfWeek(),
      disday:[],
      todytime:[],
      clarr:{
        time:'',
        program_id:'',
        user_id:'',
        program_second_id:'',
        client_id:JSON.parse(localStorage.getItem('userdata')).id,
        remark:''
      },
      prodata:[
        {
          id:'',
          name:'',
        }
      ],
      ystk:'',
      tkqd:false,
      xmid:'',
      xzxm:[],
      colorlist:[],
      sub_menus:[],
    
      smsCountdown: 0, // 倒計時的秒數
      smsCountdownTimer: null, // 倒計時的定時器
      iss:false,
      debounceTimeout: null,
      tss:true
    }
  },
  // 註冊組件
  components: {
   

    
  },
  /**
   * 數據發生改變
   */

  /**
   * 創建完畢
   */
  created() {
 

  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted() {
   
    document.addEventListener('click', this.handleClickOutside);
   this.getTodayDate()
   this.getprogram()
  // this.getdata(this.today)
  // this.getdaydata(this.today)

   this.getUserColor()
   if(this.$route.query.objectParam){
  let xgarr=JSON.parse(this.$route.query.objectParam)

    if(xgarr){
      this.clarr.time=xgarr.time
      this.clarr.id=xgarr.id
      this.clarr.user_id=xgarr.user_id
      this.clarr.remark=xgarr.remark =='null' ? '':xgarr.remark
      this.clarr.program_id=xgarr.program_id
      this.program_second_id=xgarr.program_second_id
      let xzxmarr=xgarr.program_second_id.split(',')
      this.today.program_id=xgarr.program_id
      let timearr=xgarr.time.split(' ')[0].split('-')
      this.today.year=timearr[0]
      this.today.month=timearr[1]
      this.today.day=timearr[2]
      this.today.name=xgarr.program
      let that=this
      xzxmarr.forEach(el=>{
   
        that.xzxm.push(Number(el))
     })

      this.getdata(this.today)

    }

  }
},
  /** 2024/07/2
   * 裏麵的方法隻有被調用才會執行
   */
  methods: {
    getClass(day){
  
   

      let mss= (day.month+1) < 10 ? '0'+(day.month+1):(day.month+1)


      let mss2= day.month < 10 ? '0'+day.month:day.month
      let dss= day.day
 let d2=this.today.month < 10 ? '0'+this.today.month:this.today.month

  // 给定的日期
  let givenDay = day.day;
  let givenMonth = mss; // 注意月份从0开始，所以5月是4
  let givenYear = day.year;

// 创建给定日期的Date对象
let givenDate = new Date(givenYear, givenMonth - 1, givenDay);

// 创建当前日期的Date对象
let currentDate = new Date();

// 比较日期是否相同
let isToday = givenDate.toDateString() === currentDate.toDateString();

      let colorstr='ptime'
      if(mss == this.today.month  || mss2 == this.today.month){
  
            this.listData.forEach(el=>{
       
       if(Number(el.day)== Number(dss)  && Number(el.month)== Number(mss)){
        console.log(1)
         colorstr ='ptime ish'
      
         
       }

        })
       
         

      }

      return colorstr
    },
    getClass2(day){
  
      let mss= (day.month+1) < 10 ? '0'+(day.month+1):(day.month+1)


      let mss2= day.month < 10 ? '0'+day.month:day.month
      let dss= day.day


  // 给定的日期
  let givenDay = day.day;
  let givenMonth = mss; // 注意月份从0开始，所以5月是4
  let givenYear = day.year;

// 创建给定日期的Date对象
let givenDate = new Date(givenYear, givenMonth - 1, givenDay);

// 创建当前日期的Date对象
let currentDate = new Date();

// 比较日期是否相同
let isToday = givenDate.toDateString() === currentDate.toDateString();

      let colorstr='dot'
      if(mss == this.today.month  || mss2 == this.today.month){
      
          this.listData.forEach(el=>{
              if(el.day==dss  && el.month== mss){
                colorstr ='dot is'
                
                
              }

          })

      }

      return colorstr
    },
    handleClickOutside(event) {
      // 检查点击事件是否发生在下拉菜单外部
      if (this.$refs.selectContainer && !this.$refs.selectContainer.contains(event.target)) {
        this.sopen = true;
      }
    },
    handleTouchStart(event) {
      this.startX = event.touches[0].clientX;
    },
    handleTouchMove(event) {
      if (Math.abs(event.touches[0].clientX - this.startX) > 1) {
        event.preventDefault(); // 阻止默认的滚动行为
      }
    },
    cgpro(row){
      if(this.today.program_id==row.id){
        return false
      }
      this.today.name=row.name
      this.today.program_id=row.id
      this.getdata(this.today)
      this.getdaydata(this.today)
       let sub=[]
    let that=this
          this.prodata.forEach(el=>{

            if(el.id==that.today.program_id){
              sub=el.sub_menus
            }
          })
        this.sub_menus=sub

        if(this.xmid!=this.today.program_id && this.today.program_id!=''){
      this.prodata.forEach(el=>{
         if(el.id==this.today.program_id){
          this.ystk=el.content         
         }
      })
      this.xmid =this.today.program_id
      this.xzxm=[]  
      }
      this.todytime=[]
      this.tkqd=false

      this.clarr.time=''
      this.clarr.user_id=''
      this.clarr.remark=''
      this.clarr.program_id=this.today.program_id
      this.program_second_id=''
    },
    getbgcolor(day){





      let mss= (day.month+1) < 10 ? '0'+(day.month+1):(day.month+1)

      let mss2= day.month < 10 ? '0'+day.month:day.month

      let dss= day.day


  // 给定的日期
  let givenDay = day.day;
  let givenMonth = mss; // 注意月份从0开始，所以5月是4
  let givenYear = day.year;

// 创建给定日期的Date对象
let givenDate = new Date(givenYear, givenMonth - 1, givenDay);

// 创建当前日期的Date对象
let currentDate = new Date();

// 比较日期是否相同
let isToday = givenDate.toDateString() === currentDate.toDateString();

      let colorstr=''
      if(mss == this.today.month || mss2 == this.today.month){
      
          this.listData.forEach(el=>{
              if(el.day==dss && el.month== mss){
               
                  let colorarr=el.color
                  if(colorarr.length>1){
                    colorstr="background:linear-gradient(to right,"+colorarr.join(',')+')'  
                 
                  }else{
                    colorstr="background-color:"+colorarr[0]
                  }
                
              }

          })

      }
      if(isToday){
        colorstr+=";color:#d81212"
      }
      return colorstr
    },
    bn(){
        
          if(this.tkqd){
            if(this.clarr.time==''){
                  this.$message.error('請選擇預約時間！')
                  return false
                }
            
                if(this.clarr.id){

            
                  if(this.xzxm.length>0){
                    let programs=this.xzxm.join(',')

                    this.clarr.program_second_id=programs
                   if(this.iss){
                    return false
                   }
                   this.iss=true
                    orderEdit(this.clarr)
                      .then(res => {
                    
                        if (res.code != 1) {
                          this.$message({
                            type: 'info',
                            message: res.message
                          })
                        } else {
                          this.$message({
                            message: '修改成功',
                            type: 'success'
                          })

                          this.$router.push({ path: '/user/Bookings' }) 
                          this.smsCountdown = 3; // 假設倒計時60秒
                      this.smsCountdownTimer = setInterval(() => {
                        if (this.smsCountdown > 0) {
                          this.smsCountdown -= 1;
                        } else {
                          this.iss=false
                          clearInterval(this.smsCountdownTimer);
                        }
                      }, 1000);
                        }

                      })
                      .catch(err => {
                        this.iss=false
                        this.loading = false
                        this.$message.error('菜單加載失敗，請稍後再試！')
                      })
                    }else{
                      this.iss=false
                      this.$message.error('至少選擇一種項目！')
                      return false
                    }

                    }else{
                      if(this.xzxm.length>0){
                      let programs=this.xzxm.join(',')

                      this.clarr.program_second_id=programs
                      if(this.iss){
                        return false
                      }
                      this.iss=true
                              orderSave(this.clarr)
                        .then(res => {
                      
                          if (res.code != 1) {
                          
                            this.$message({
                              type: 'error',
                              message:  res.message
                            })
                          
                          } else {
                            this.$message({
                              message: '預約成功',
                              type: 'success'
                            })

                            this.$router.push({ path: '/user/Bookings' }) 
                            this.smsCountdown = 3; // 假設倒計時60秒
                                        this.smsCountdownTimer = setInterval(() => {
                                          if (this.smsCountdown > 0) {
                                            this.smsCountdown -= 1;
                                          } else {
                                            this.iss=false
                                            clearInterval(this.smsCountdownTimer);
                                          }
                                        }, 1000);
                            }
                          

                        })
                        .catch(err => {
                          this.iss=false
                          this.loading = false
                          this.$message.error('菜單加載失敗，請稍後再試！')
                        })
                      }else{
                        this.iss=false
                        this.$message.error('至少選擇一種項目！')
                        return false
                      }
                    
                    }

          }else{
            
           // this.$message.error('請同意條款！')
                return false
          }
    },
    tkqdbtn(){
      this.dialogVisible = false
      this.tkqd = true
    },
    handleChange(val){

      if(this.xmid!=val && val!=''){
      this.prodata.forEach(el=>{
         if(el.id==val){
          this.ystk=el.content         
         }
      })
      this.xmid =val
      this.xzxm=[]
      }
    },
    proxz(item){

     const index = this.xzxm.indexOf(item.id);
    if (index !== -1) {
      this.xzxm.splice(index, 1);
    }else{
      this.xzxm.push(item.id)
    }
    

    },
    xzsj(item){
      this.clarr.time=item.dateTime
      this.clarr.user_id=item.user_id
    },
    disabledDate(date) {
    // 获取不要禁用的日子列表


    // 获取当前日期的年月日部分（不包含时间）
    const todayWithoutTime = new Date();
    todayWithoutTime.setHours(0, 0, 0, 0); // 确保时间部分为0，仅比较日期

    // 创建一个只含日期部分的Date对象用于比较
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    // 如果date在今天之前或者在禁用列表里，则禁用
    // 注意：这里逻辑调整为，不在禁用列表内且不是过去日期才不禁用，即逻辑取反后判断
    const isNotDisabled = dateOnly >= todayWithoutTime ? true : false;

    return !isNotDisabled; // 如果是过去日期或在禁用列表内，则返回true禁用该日期
},
    getDayOfWeek() {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const today = new Date();
    return 'Sunday';
  },
    getTodayDate() {
    const now = new Date();
    this.today.year = now.getFullYear();
    this.today.month = ('0' + (now.getMonth() + 1)).slice(-2); // 月份是從0開始的
    this.today.day = ('0' + now.getDate()).slice(-2);
  },
  onDateChange(date){

  let dayarr=date.split('-')
  this.xzxm=[]
  this.clarr.time=''
this.clarr.user_id=''

  if(dayarr[1]==this.today.month && dayarr[0]==this.today.year){
    this.today.day=dayarr[2]
    this.getdaydata(this.today)


  }else{
    
    this.today.year=dayarr[0]
    this.today.month=dayarr[1]
    this.today.day=dayarr[2]
 

    this.debounce(() => {
        this.getdatall();
      }, 300);
  }

  },
  getprogram(){
    let that=this
    program()
      .then(res => {
    
        if (res.data.code != 1) {
          this.$message({
            type: 'info',
            message: res.data.message
          })
        } else {
          this.prodata = res.data.data
          this.prodata.forEach(el=>{
            if(el.id==that.clarr.program_id){
              that.sub_menus=el.sub_menus
              that.ystk=el.content    
            }
          })
        }

      })
      .catch(err => {
        this.loading = false
        this.$message.error('菜單加載失敗，請稍後再試！')
      })
  },
  getUserColor(){
    userColor()
      .then(res => {

        if (res.data.code != 1) {
          this.$message({
            type: 'info',
            message: res.data.message
          })
        } else {
          this.colorlist = res.data.data

        }

      })
      .catch(err => {
        this.loading = false
        this.$message.error('菜單加載失敗，請稍後再試！')
      })
  },
      getdaydata(parameter) {
    this.loading = true
  

    /***
     * 調用接口，註釋上麵模擬數據 取消下麵註釋
     */
    dayWorking(parameter)
      .then(res => {
        this.loading = false
  
        if (res.data.code != 1) {
          this.$message({
            type: 'info',
            message: res.data.message
          })
        } else {
          this.listdayData = res.data.data

          let na=[]
      
          res.data.data.forEach(e => {

         
                e.stime=e.dateTime.split(' ')[1]

             
                na.push(e)
           
           
        
          });
          this.todytime=na
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('菜單加載失敗，請稍後再試！')
      })
  },

 handleDateClick(date) {
 
  },
  goToPrevWeek() {

    const now = new Date();
    const year = now.getFullYear();
    let month = now.getMonth() + 1 ;
    const date =now.getDate();

    let nd=JSON.parse(JSON.stringify(this.today))


          if(nd.month==1){
            nd.year=Number(nd.year)-1
            nd.month=12
          }else{
            nd.month=Number(nd.month)-1 < 10 ? '0'+(Number(nd.month)-1):Number(nd.month)-1
          }
          const dateObject = new Date( nd.year, nd.month, '01').getTime()
  
   
          if(dateObject < now.getTime()){
             return false
          }

          this.today=nd

          this.$refs.calendar.lastMonth()
        
  
          this.debounce(() => {
        this.getdatall();
      }, 300);
      
   

  },
  goToNextWeek() {

    this.$refs.calendar.nextMonth()


    if(this.today.month==12){
            this.today.year=Number(this.today.year)+1


            
            this.today.month='01'
          }else{
            this.today.month= Number(this.today.month)+1  < 10 ? '0'+(Number(this.today.month)+1):Number(this.today.month)+1
          }
      

      this.debounce(() => {
        this.getdatall();
      }, 300);
  
  },
  getdatall(){
 
    this.getdata(this.today)
    this.getdaydata(this.today)
  },
  debounce(func, delay) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => func.apply(this, arguments), delay);
    },

  getdata(parameter) {
    this.loading = true
  
let that=this
    /***
     * 調用接口，註釋上麵模擬數據 取消下麵註釋
     */
    Working(parameter)
      .then(res => {
        this.loading = false
   
        if (res.data.code != 1) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {




          this.listData = res.data.data

    
      console.log(this.listData)
    

        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('菜單加載失敗，請稍後再試！')
      })
  }
   
  }
}
</script>


 <style>

</style>
 


// WEBPACK FOOTER //
// src/views/user/Booknow.vue